"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feedback = function Feedback(_ref) {
  var error = _ref.error,
      id = _ref.id;
  return _react2.default.createElement(
    "span",
    { className: "luna-form__feedback", id: "inputFeedbackText-" + id },
    error
  );
};

exports.default = Feedback;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/Feedback.js